export function cmp<T extends string | number>(element: T): (a: T, b: T) => number {
	if (typeof element === "number") {
		return function (a: number, b: number): number {
			return a - b;
		} as (a: T, b: T) => number;
	}
	if (typeof element === "string") {
		return function (a: string, b: string): number {
			return a.localeCompare(b);
		} as (a: T, b: T) => number;
	}
	throw new TypeError("Element is neither number nor string");
}
